import { render, staticRenderFns } from "./EfasCallback.vue?vue&type=template&id=16a46bc2&scoped=true&"
import script from "./EfasCallback.vue?vue&type=script&lang=js&"
export * from "./EfasCallback.vue?vue&type=script&lang=js&"
import style0 from "./EfasCallback.vue?vue&type=style&index=0&id=16a46bc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a46bc2",
  null
  
)

export default component.exports